export const DEFAULT_IBAN_PLACEHOLDER = 'AB1212341234121234567890'
export const IBAN_PLACEHOLDERS: Record<string, string> = {
  ad: 'AD1400080001001234567890',
  at: 'AT483200000012345864',
  be: 'BE71096123456769',
  bg: 'BG18RZBB91550123456789',
  hr: 'HR1723600001101234565',
  cy: 'CY21002001950000357001234567',
  cz: 'CZ5508000000001234567899',
  dk: 'DK9520000123456789',
  ee: 'EE471000001020145685',
  fi: 'FI1410093000123458',
  fr: 'FR7630006000011234567890189',
  de: 'DE75512108001245126199',
  gi: 'GI56XAPO000001234567890',
  gr: 'GR9608100010000001234567890',
  hu: 'HU93116000060000000012345676',
  is: 'IS750001121234563108962099',
  ie: 'IE64IRCE92050112345678',
  it: 'IT60X0542811101000000123456',
  lv: 'LV97HABA0012345678910',
  li: 'LI7408806123456789012',
  lt: 'LT601010012345678901',
  lu: 'LU120010001234567891',
  mt: 'MT31MALT01100000000000000000123',
  mc: 'MC5810096180790123456789085',
  nl: 'NL02ABNA0123456789',
  no: 'NO8330001234567',
  pl: 'PL10105000997603123456789123',
  pt: 'PT50002700000001234567833',
  ro: 'RO66BACX0000001234567890',
  sm: 'SM76P0854009812123456789123',
  sk: 'SK8975000000000012345671',
  si: 'SI56192001234567892',
  es: 'ES7921000813610123456789',
  se: 'SE7280000810340009783242',
  ch: 'CH5604835012345678009',
  gb: 'GB33BUKB20201555555555',
  va: 'VA59001123000012345678',
}

/**
 * These are the countries supported by the taxidpro api.
 * We use this service to validate tax numbers.
 * More info: https://taxid.pro/docs/countries
 */
export const TAXID_PRO_COUNTRIES = [
  'al',
  'ad',
  'ar',
  'am',
  'aw',
  'au',
  'at',
  'az',
  'bd',
  'bb',
  'by',
  'be',
  'bz',
  'bo',
  'br',
  'bn',
  'bg',
  'ca',
  'cl',
  'cn',
  'co',
  'cr',
  'hr',
  'cu',
  'cw',
  'cy',
  'cz',
  'dk',
  'do',
  'ec',
  'eg',
  'sv',
  'ee',
  'fo',
  'fi',
  'ge',
  'de',
  'gi',
  'gr',
  'gl',
  'gt',
  'gg',
  'hk',
  'hu',
  'is',
  'in',
  'id',
  'ie',
  'il',
  'it',
  'jm',
  'jp',
  'je',
  'kz',
  'kw',
  'kg',
  'lv',
  'li',
  'lt',
  'lu',
  'mk',
  'my',
  'mt',
  'mu',
  'mx',
  'md',
  'mc',
  'me',
  'ma',
  'nl',
  'nz',
  'ni',
  'xi',
  'no',
  'pk',
  'py',
  'pe',
  'ph',
  'pl',
  'pt',
  'ro',
  'ru',
  'ws',
  'sm',
  'rs',
  'sk',
  'si',
  'za',
  'kr',
  'es',
  'lk',
  'se',
  'ch',
  'tj',
  'th',
  'tt',
  'tn',
  'tr',
  'tm',
  'ua',
  'gb',
  'us',
  'uy',
  'uz',
  've',
]

/**
 * We have agreements with investors that do not allow us to sell our product
 * in countries sanctionated by the OFAC
 */
export const FORBIDDEN_COUNTRIES = ['cu', 'kp', 'sy', 'ir', 'ru', 'ua']
